<template>
    <div class="body">
        <div>{{labelLeft}}</div>
        <label class="switch">
            <input type="checkbox" @change="handelInput" v-model="model">
            <span class="slider"></span>
        </label>
        <div>{{labelRight}}</div>
    </div>
</template>
    
<script>

export default {
    name: "ToggleSlide",
    props: {
        value: {
            required: true,
        },
        labelLeft: {
            default: '',
        } ,
        labelRight: {
            default: '',
        } ,
    },
    data: function(){
        return {
            model: this.value,
        }
    },
    methods:{
        handelInput(e){
            this.$emit('input', this.model);
        }
    },
}
</script>

<style lang="scss" scoped>

    @import "../../assets/styles/_globals";

    .body {
        height: $height_mid;
        display: flex;
        justify-content: center;
        align-items: center;

        > div {
            text-align: center;
            width:calc(50% - 30px);
        }
    }

    .switch {
        position: relative;
        display: inline-block;
        width: 60px;
        height: $height_s;
    }

    /* Hide default HTML checkbox */
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 22px;
        width: 22px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }

    input:checked + .slider {
        background-color: $seltec_color;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px $seltec_color;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX($height_s);
        -ms-transform: translateX($height_s);
        transform: translateX($height_s);
    }

</style>